/**
 * API CEI Apps
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `ATIVA` - Ativa * `PENDENTE` - Pendente * `DESATIVADA` - Desativada
 */
export const SituacaoEnum = {
    Ativa: 'ATIVA',
    Pendente: 'PENDENTE',
    Desativada: 'DESATIVADA'
} as const;
export type SituacaoEnum = typeof SituacaoEnum[keyof typeof SituacaoEnum];

